import { strings } from "../../../localization";
import {
	ButtonLayout,
	ButtonLink,
	ButtonPrimary,
	Grid,
	GridItem,
	IconWarningLight,
	Text2,
	Text3,
	skinVars,
	useScreenSize,
} from "@telefonica/mistica";
import React, {useEffect} from "react";
import { FeedbackContainer, ScreenResponsive } from "../../../components";
import { observer, useLocalObservable } from "mobx-react-lite";
import { PostBalanceInquiryRequestFetchStore } from "../../../stores";
import { useGlobalStore } from "../../../contexts/globalStoreContext";
import { useAnalytics } from "../../../hooks/useAnalytics";
import { useNavigateCustom } from "../../../hooks";

export const OngoingOperation: React.FC = observer(() => {
	const errorInfo = strings.components.connectionFeedback.errors;

	const { isDesktopOrBigger } = useScreenSize();
	const navigation = useNavigateCustom();
	const { addAnalyticEvent, updatePageView } = useAnalytics();
	const { authenticationStore } = useGlobalStore();
	const store = useLocalObservable(
		() => new PostBalanceInquiryRequestFetchStore(
			authenticationStore,
			() => navigation("/connect-fgts-balance"),
		),
	);

	const handleAddAnalyticEvent = (description: string ): void => {
		addAnalyticEvent({
			component: "body",
			action: "click.button",
			description,
			step: "fgts:tente-conectar-mais-tarde",
			value: "",
		}, {applySanitize: true});
	};

	const onLogoutPress = React.useCallback(
		() => {
			handleAddAnalyticEvent(errorInfo.ongoingOperation.buttons.linkButton);
			authenticationStore.logout();
			navigation("/");
		},
		[],
	);

	const handleOnPressButton = async (): Promise<void> => {
		handleAddAnalyticEvent(errorInfo.ongoingOperation.buttons.primaryButton);
		store.fetchShelf.fetch();
	};

	useEffect(()=>{
		addAnalyticEvent({
			component: "body",
			action: "view-error",
			description: "tente-conectar-mais-tarde",
			step: "fgts:tente-conectar-mais-tarde",
			value: "",
			event: "non_interaction",
		}, {applySanitize: true});

		updatePageView({
			name: "Vivo Money FGTS Tente Conectar Mais Tarde",
			pagePath: "/fgts/tente-conectar-mais-tarde",
		});
	},[]);

	return (
		<ScreenResponsive>
			<Grid justifyContent="center">
				<GridItem>
					<FeedbackContainer
						icon={<IconWarningLight size={64} color={skinVars.colors.controlError} />}
						title={errorInfo.ongoingOperation.title}
						description={errorInfo.ongoingOperation.text}
					>
						<ButtonLayout align={isDesktopOrBigger ? "left" : "center"}>
							<ButtonPrimary
								onPress={handleOnPressButton}
								showSpinner={store.fetchShelf.loader.isLoading}
								disabled={store.fetchShelf.loader.isLoading}
								style={{ width: isDesktopOrBigger ? "auto" : "100%" }}
							>
								<Text3 medium color={skinVars.colors.textButtonPrimary}>
									{errorInfo.ongoingOperation.buttons.primaryButton}
								</Text3>
							</ButtonPrimary>
							<ButtonLink
								onPress={() => onLogoutPress()}
								disabled={store.fetchShelf.loader.isLoading}
							>
								{isDesktopOrBigger ? (
									<Text3 medium color={skinVars.colors.textLink}>
										{errorInfo.ongoingOperation.buttons.linkButton}
									</Text3>
								) : (
									<Text2 medium color={skinVars.colors.textLink}>
										{errorInfo.ongoingOperation.buttons.linkButton}
									</Text2>)}
							</ButtonLink>
						</ButtonLayout>
					</FeedbackContainer>
				</GridItem>
			</Grid>
		</ScreenResponsive>
	);
});

export default OngoingOperation;
